import React from 'react'
import AboutHero from '../components/AboutHero/AboutHero'
import ContactSection from '../components/ContactSection/ContactSection'
import Footer from '../components/Footer/Footer'

const Contact = () => {
  return (
    <>
    <AboutHero page='contact' img="/contactus-hero.png"
    title= "We’re Here to Help You See Better"
    subtitle="Questions, bookings, or frame advice — our opticians are just a message away."
    />
    <div className='bg_gradient'>
    <ContactSection />
    </div>
    <Footer />
    </>
  )
}

export default Contact